module.exports = __webpack_public_path__ + "img/flag-CO.864484ab.png";